// Chercher dans toutes les offres suivies, et le tri rapide (revue du
// 2026-10-11 : deux gestes qui existaient avant la refonte et que « Mes
// offres » avait perdus). Radar seulement.

import { useEffect, useState } from 'react'
import { Search, Zap } from 'lucide-react'
import { get, post } from '../lib/api'
import { navigate } from '../lib/router'
import { useT } from '../lib/i18n'
import { ActionButton, useToast } from './common'
import { Carte, type CarteOffre } from '../pages/Accueil'

export function RechercheOffres() {
  const t = useT()
  const [q, setQ] = useState('')
  const [res, setRes] = useState<CarteOffre[] | null>(null)
  useEffect(() => {
    if (q.trim().length < 2) {
      setRes(null)
      return
    }
    const minuterie = setTimeout(() => {
      get<CarteOffre[]>(`/api/radar/recherche?q=${encodeURIComponent(q.trim())}`).then(setRes, () => setRes([]))
    }, 250)
    return () => clearTimeout(minuterie)
  }, [q])
  return (
    <section className="acc-sec">
      <div className="acc-liste">
        <label className="acc-ligne emp-cherche">
          <Search size={15} />
          <input className="grow" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('cherche.placeholder')} />
        </label>
      </div>
      {res && (res.length === 0 ? (
        <p className="field-help">{t('cherche.rien')}</p>
      ) : (
        <div className="acc-cartes">{res.map((o) => <Carte key={o.id} o={o} />)}</div>
      ))}
    </section>
  )
}

/** Une offre à la fois : Je regarde, Plus tard, Pas pour moi. */
export function TriRapide({ onChanged }: { onChanged: () => void }) {
  const t = useT()
  const toast = useToast()
  const [liste, setListe] = useState<CarteOffre[] | null>(null)
  const [i, setI] = useState(0)
  if (!liste)
    return (
      <ActionButton onClick={async () => setListe(await get<CarteOffre[]>('/api/radar/a-trier'))}>
        <Zap size={13} />{t('tri.ouvrir')}
      </ActionButton>
    )
  const o = liste[i]
  if (!o)
    return (
      <p className="field-help">
        {t('tri.fini')} <button className="linkbtn" onClick={() => { setListe(null); setI(0) }}>{t('tri.fermer')}</button>
      </p>
    )
  async function trancher(status: 'later' | 'skip') {
    await post(`/api/offers/${o.id}/status`, { status })
    toast(t(status === 'later' ? 'tri.plusTardOk' : 'tri.pasPourMoiOk'))
    setI((n) => n + 1)
    onChanged()
  }
  return (
    <section className="acc-sec">
      <div className="acc-entete">
        <span className="acc-eyebrow">{t('tri.titre', { n: i + 1, total: liste.length })}</span>
        <button className="linkbtn" onClick={() => { setListe(null); setI(0) }}>{t('tri.fermer')}</button>
      </div>
      <div className="acc-cartes"><Carte o={o} /></div>
      <div className="tri-actions">
        <ActionButton variant="primary" onClick={() => navigate(`#/offre/${o.id}`)}>{t('tri.voir')}</ActionButton>
        <ActionButton onClick={() => trancher('later')}>{t('tri.plusTard')}</ActionButton>
        <ActionButton onClick={() => trancher('skip')}>{t('tri.pasPourMoi')}</ActionButton>
        {/* « Passer » se lisait « écarter » à côté de « Pas pour moi » : c'est
            seulement l'offre suivante, sans rien décider, et elle se tient à part. */}
        <button className="linkbtn tri-suivante" onClick={() => setI((n) => n + 1)}>{t('tri.passer')}</button>
      </div>
    </section>
  )
}
